
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`React Native`}</h2>
    <p>{`styled-components can be used with React Native in the same way and with the
same import. Try this example with `}<a parentName="p" {...{
        "href": "https://snack.expo.io/@danielmschmidt/styled-components"
      }}>{`Snack by Expo`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'
import styled from 'styled-components/native'

const StyledView = styled.View\`
  background-color: papayawhip;
\`

const StyledText = styled.Text\`
  color: palevioletred;
\`

class MyReactNativeComponent extends React.Component {
  render() {
    return (
      <StyledView>
        <StyledText>Hello World!</StyledText>
      </StyledView>
    )
  }
}
`}</code></pre>
    <p>{`We also support more complex styles (like `}<inlineCode parentName="p">{`transform`}</inlineCode>{`), which would normally
be an array, and shorthands (e.g. for `}<inlineCode parentName="p">{`margin`}</inlineCode>{`) thanks to
`}<a parentName="p" {...{
        "href": "https://github.com/styled-components/css-to-react-native"
      }}><inlineCode parentName="a">{`css-to-react-native`}</inlineCode></a>{`!`}</p>
    <blockquote>
      <p parentName="blockquote">{`Note that the `}<inlineCode parentName="p">{`flex`}</inlineCode>{` property works like CSS shorthand, and not the legacy
`}<inlineCode parentName="p">{`flex`}</inlineCode>{` property in React Native. Setting `}<inlineCode parentName="p">{`flex: 1`}</inlineCode>{` sets `}<inlineCode parentName="p">{`flexShrink`}</inlineCode>{`
to `}<inlineCode parentName="p">{`1`}</inlineCode>{` in addition to setting `}<inlineCode parentName="p">{`flexGrow`}</inlineCode>{` to `}<inlineCode parentName="p">{`1`}</inlineCode>{` and `}<inlineCode parentName="p">{`flexBasis`}</inlineCode>{` to `}<inlineCode parentName="p">{`0`}</inlineCode>{`.`}</p>
    </blockquote>
    <p>{`Imagine how you'd write the property in React Native, guess how you'd transfer
it to CSS, and you're probably right:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const RotatedBox = styled.View\`
  transform: rotate(90deg);
  text-shadow-offset: 10px 5px;
  font-variant: small-caps;
  margin: 5px 7px 2px;
\`
`}</code></pre>
    <p>{`Some of the differences to the web-version are, that you cannot use the
`}<inlineCode parentName="p">{`keyframes`}</inlineCode>{` and `}<inlineCode parentName="p">{`createGlobalStyle`}</inlineCode>{` helpers since React Native doesn't support
keyframes or global styles. We will also warn you if you use media queries or
nest your CSS.`}</p>
    <blockquote>
      <p parentName="blockquote">{`In v2 we support percentages. To make this possible we need to enforce units
for all shorthands. If you're migrating to v2,
`}<a parentName="p" {...{
          "href": "https://github.com/styled-components/styled-components-native-code-mod"
        }}>{`a codemod is available`}</a>{`.`}</p>
    </blockquote>
    <h3>{`Simpler usage with the metro bundler`}</h3>
    <p>{`If you'd prefer to just import `}<inlineCode parentName="p">{`styled-components`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`styled-components/native`}</inlineCode>{`, you can add a `}<a parentName="p" {...{
        "href": "https://facebook.github.io/metro/docs/configuration#resolvermainfields"
      }}><inlineCode parentName="a">{`resolverMainFields`}</inlineCode>{` configuration`}</a>{` that includes `}<inlineCode parentName="p">{`"react-native"`}</inlineCode>{`. This used to be supported in metro by default (and currently does work in haul) but appears to have been removed at some point.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;